import * as React from "react";
import styled from "styled-components";
import {
  ConstBreakPoint,
  ConstColor,
  ConstMargin,
  ConstWidth,
} from "../../../../config/styles_const/styles_const";

interface IProps
  extends React.DetailedHTMLProps<
    React.ThHTMLAttributes<HTMLTableHeaderCellElement>,
    HTMLTableHeaderCellElement
  > {
  widthSize?: string;
}

const ThDefault: React.FC<IProps> = (props) => {
  const { children, widthSize, ...ThProps } = props;

  return <th {...ThProps}>{children}</th>;
};

const Th = styled(ThDefault)`
  // border-top: ${ConstMargin.TableBorder} solid ${ConstColor.White};
  // border-bottom: ${ConstMargin.TableBorder} solid ${ConstColor.White};
  background-color: ${ConstColor.TableTh};
  padding: 10px;
  display: block;
  text-align: left;
  // margin-bottom: -${ConstMargin.TableBorder};
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    width: ${(props) =>
      props.widthSize ? props.widthSize : ConstWidth.TableThWidth};
    padding: 10px;
    display: table-cell;
    text-align: center;
    margin-bottom: 0;
  }
`;

export default Th;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/table/th.tsx